import { OffersState } from 'features/offers/interface/store.interface';

export const hasOfferDefinitionId = (data: OffersState, targetOfferId: number, isLoggedIn: boolean) => {
	if (!data && !isLoggedIn && !targetOfferId) return false;
	return [...(data.bonusesActive || []), ...(data.bonusesQueued || []), ...(data.freebetsActive || [])].some((item) => {
		return item.offerDefinitionId === targetOfferId;
	});
};
